
import state from './../../zviz2/zviz/state';
import config from './../../config';

import {default as ActiveFilter, Controller as ActiveFilterController} from './../filter/active';
import {extend} from './../../zviz2/zviz/functions';
//import {LifeCycle} from './../zviz2/zviz/cycle';

class Controller extends ActiveFilterController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.filter = 'region';

    }

    init(renderer){
        this.filterChange();
        super.init(renderer);
    }

    filterChange(){
        let r = state.get('filter.' + this.data.dimensions[0]);
        let c = state.get('filter.' + this.data.dimensions[1]);
        this.filter = this.data.dimensions[0];
        if( c ){
            this.filter = this.data.dimensions[1];
        }

        this.update();
    }

    getFilterName(){
        return this.filter;
    }

    formatValue(input){
        let result = super.formatValue(input);
        
        return config.data.dimensionTitles[this.filter] + ': ' + result;
    }

    getFontSize(){
        return '10pt';
    }


}


let Blueprint = extend({
    type: Controller,
    listeners: [
        (ctrl) => (ctrl.addListener(state, [ctrl, ctrl.filterChange], 'filter'))
    ],
    properties: {
        style: { 
            marginBottom: (ctrl) => ( ctrl.hasFilters()? '0px': '' ),
            maxWidth: '350px'
        },
    },
    children: [ (ctrl) => ( ctrl.getChildren() ) ]
}, ActiveFilter);



export default Blueprint;
export {Controller, Blueprint};
